import { render, staticRenderFns } from "./AddInformation.vue?vue&type=template&id=bf2f4e02&scoped=true&"
import script from "./AddInformation.vue?vue&type=script&lang=js&"
export * from "./AddInformation.vue?vue&type=script&lang=js&"
import style0 from "./AddInformation.vue?vue&type=style&index=0&id=bf2f4e02&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f4e02",
  null
  
)

export default component.exports